import { makeAutoObservable } from 'mobx'

export default class ModalStore {
  modals = new Map()

  constructor(rootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
  }

  get openModalsIds() {
    return [...this.modals]
      .filter(([_, m]) => m.isOpen)
      .map(([k]) => k)
      .flat()
  }

  get hasOpenModals() {
    return this.openModalsIds.length > 0
  }

  modalIsOpen(id) {
    return this.openModalsIds.includes(id)
  }

  addModal(id) {
    this.modals.set(id, {
      isOpen: false,
      data: null,
    })
  }

  getData(id) {
    if (this.modals.has(id)) {
      return this.modals.get(id).data
    }
  }

  openModal(id, data) {
    if (this.modals.has(id)) {
      this.modals.set(id, { isOpen: true, data })
    }
  }

  closeModal(id) {
    if (this.modals.has(id)) {
      const modal = this.modals.get(id)
      this.modals.set(id, { ...modal, isOpen: false, data: null })
    }
  }

  toggleModal(id, data) {
    const modal = this.modals.get(id)

    if (modal?.isOpen) {
      this.closeModal(id)
    } else {
      this.openModal(id, data)
    }
  }
}
